<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeAnnouncement"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeAnnouncement" :campaign="campaign" />

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>
  </div>
</template>

<script>
import { Model } from "survey-core";
import { mapState } from "vuex";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import moment from "moment";
import MicrositeAxios from "@/config/microsite-service";
import { addClassQlEditorToSDDisplay, customThemeSurveyJS } from "../../../config/general-function";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";

export default {
  name: "MicrositeAnnouncement",
  inject: ["isAppLoading"],
  components: {
    Survey,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    campaign: null,
    survey: null,
    surveyJson: null,
    themeJson: null,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },
    history: [],

    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  async created() {
    await this.getCampaign();
    await this.getSurveyAndTheme();

    this.survey = new Model(this.surveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;
    const templateName = this.$store.state?.microsite?.campaign?.template?.name;
    if (templateName === "Survey") {
      this.survey.showNavigationButtons = false;
    }
    this.handleSubmit();
    // ========== ========== ========== ==========
    addClassQlEditorToSDDisplay();
  },
  computed: {
    ...mapState("microsite", ["history_code"]),
    ...mapState("defaultSystem", ["site"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    async getCampaign() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "microsite-error",
          params: { slug: this.$route.params.slug },
        });
      }
    },
    getSurveyAndTheme() {
      const surveyJson = JSON.parse(this.campaign.survey_json);
      if (surveyJson && surveyJson.announcement) {
        this.surveyJson = surveyJson.announcement;
      } else {
        this.surveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).announcement;
      }

      // set theme
      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
    handleSubmit() {
      this.survey.onComplete.add(async () => {
        await this.onSubmit();
      });
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        if (["image_confirm"].includes(options.question.name)) {
          const element = options.htmlElement;
          element.style.cursor = "pointer"; // Optional: Change cursor to indicate clickable
          element.onclick = () => {
            if (options.question.name == "image_confirm") {
              const isSurveyHasErrors = this.survey.hasErrors();
              if (isSurveyHasErrors) return;
              this.onSubmit();
            }
          };
        }
      });
    },
    async onSubmit() {
      const templateName = this.$store.state.microsite.campaign.template.name;
      if (templateName === "Survey") {
        this.$router.push({ name: "microsite-register" });
      } else {
        this.$router.push({ name: "microsite-menu" });
      }
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
  },
};
</script>

<style scoped>
table {
  width: 100%;
  table-layout: fixed;
  background-color: white;
  border-spacing: 0;
  /* display: block; */
  margin: 0 auto;
  white-space: nowrap;
}

th {
  border-bottom: 1px solid black;
  padding: 0;
  font-weight: 600;
  font-size: 11px;
  /* min-width: 60px; */
  font-size: clamp(0.7rem, 1.5vw, 1rem);
}

tr {
  font-size: 11px;
  height: 42px;
  /* min-width: 60px; */
  font-size: clamp(0.6rem, 1.2vw, 0.9rem);
}

.header-rank,
.body-rank {
  border-right: 1px solid black;
  width: 10%;
}

.header-name,
.body-name {
  border-right: 1px solid black;
  width: 40%;
}

.header-phone,
.body-phone {
  border-right: 1px solid black;
  width: 30%;
}

.header-total-spend,
.body-total-spend {
  width: 20%;
}

/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
